import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => ({
  banner: {
    zIndex: 1,
    // flexGrow: 0.1,
    margin: '200px',
    height: '100px',
    width: '50%',
    // position: 'absolute'
    alignItems: 'center',
    borderRadius: '30px',
    backgroundColor: 'black'
  },
  container: {
    ['@media (min-width:768px)']: {
      marginTop: 10,
      display: 'flex',
      flexDirection: 'row'
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    alignContent: 'center'
  },
  btnContainer: {
    ['@media (min-width:768px)']: {
      marginTop: 10,
      display: 'flex',
      // flexDirection: 'row',
      // alignItems: 'end',
      // alignContent: 'end'
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'end',
    alignContent: 'end'
  },
  new__meeting: {
    color: 'rgb(43,158,250)'
  },

  meetingInfo: {
    ['@media (min-width:768px)']: {
      margin: '100px',
    },
    // margin: '100px',
    width: '100%',
    height: 'auto',
    color: 'white'
  },
  meetingInfoNew: {
    ['@media (min-width:998px)']: {
      maxWidth: '800px',
    },
    ['@media (min-width: 768px) and (max-width: 998px)']: {
      maxWidth: '600px', 
    },
    position: 'relative',
    
  },
  coverImg: {
    ['@media (min-width:998px)']: {
      maxWidth: '800px',
    },
    ['@media (min-width: 768px) and (max-width: 998px)']: {
      maxWidth: '600px', 
    },
    display: 'block',
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  correctImg: {
    height: '156px',
    width: '156px',
    position: 'absolute',
    bottom: -50, 
    transform: 'translateX(-50%)', 
    left: '50%', 
  },
  endMeetTitle: {
    textAlign: 'center',
    color: '#000000',
    fontSize: '33px',
  },
  overlayText: {
    fontSize: '26px',
    textAlign: 'center',
    fontWeight: 'bold',
    paddingTop: '50px',
    color: '#000000',
    marginBottom: '0px',
  },
  overlayText2: {
    fontSize: '18px',
    textAlign: 'center',
    paddingTop: '-50px',
    color: '#000000',
  },
  infoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  
  meetingInfoCover: {
    display: 'flex',
  },
  infoFont: {
    color: '#FFFFFF',
    textAlign: 'center',
  },
  recording: {
    display: 'flex',
    flexDirection: 'row'
  },
  root: {
    minWidth: 275,
    margin: 'auto'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)'
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  },
  centeredFlex: {
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'black',
    color: 'white',
    borderRadius: '30px'
  }
}));
